import { compose, createStore } from "redux";
import persistState from "redux-localstorage";
import rootReducer from "./reducers";

const enhancer = compose(persistState());
export const store = createStore(rootReducer, enhancer);
